export const ENDPOINTS = {
  advertisements: {
    releventAdvertisement: () => "student/advertisements",
    trackClick: (advertisementId: number) =>
      `student/advertisements/${advertisementId}/click`,
    closeModal: (advertisementId: number) =>
      `student/advertisements/${advertisementId}/close`,
  },
  enrolledCourses: {
    index: () => "student/enrollments",
    show: (roundId: number) => `student/enrollments/rounds/${roundId}/details`,
    attend: (roundId: number, lectureType: string, lectureId: number) =>
      `student/enrollments/rounds/${roundId}/lectures/${lectureType}/${lectureId}/attend`,
    addTask: (roundId: number, lectureType: string, lectureId: number) =>
      `student/enrollments/rounds/${roundId}/lectures/${lectureType}/${lectureId}/task`,
  },
  feedbacks: {
    makeAllReadById: (id: number) => `student/make-all-read/${id}`,
    counts: () => "student/get-count-unread-feedback",
    all: () => "student/home/all-feedback",
  },
  home: {
    stats: () => "/student/home/stats",
    ranking: () => "student/home/ranking",
    progress: () => "student/home/progress",
    lecturesStats: () => "student/home/lectures/stats",
    latestFeedbacks: () => "student/home/latest-feedback",
    topOne: () => "student/home/top-one",
    absenceAlert: () => "student/home/absence-alert",
    missedTasksCheck: () => "student/home/missed-tasks-check",
  },
  achievements: {
    topOne: (id: number) => `achievements/top-one/${id}`,
  },
  certificates: {
    index: () => "student/certificates",
    generate: (roundId: number) =>
      `student/certificates/rounds/${roundId}/generate`,
    show: (uuid: string) => `certificates/${uuid}`,
  },

  notifications: {
    index: () => "student/notifications/latest",
    markReadById: (notificationId: string | number) =>
      `student/notifications/${notificationId}`,
    markAllRead: () => "student/notifications/read-all",
  },
  profileInfo: {
    arabCountries: () => "/admin/arab-countries",
    professions: () => "/admin/professions",
    governorates: (id: number) => `/admin/governorates/${id}`,
    colleges: () => "/admin/colleges",
  },
  profile: {
    show: () => "student/profile",
    update: () => "student/profile/update",
    socialLinks: () => "student/profile-link",
    updateSocialLinks: () => "student/profile-link",
  },
  projects: {
    index: () => "student/projects",
    add: () => "student/projects",
    edit: (projectId: number) => `student/projects/${projectId}`,
    delete: (projectId: number) => `student/projects/${projectId}`,
  },
  settings: {
    index: () => "/admin/settings?pagination=none",
  },
  skills: {
    index: () => "student/skills",
    add: () => "student/skills",
  },
  surveys: {
    index: () => "student/surveys",
    show: (slug: string) => `student/surveys/${slug}`,
    submit: (slug: string) => `student/surveys/${slug}/answer`,
  },
  tickets: {
    index: () => "student/tickets",
    show: (ticketId: number) => `student/tickets/${ticketId}`,
    replies: (ticketId: number) => `student/tickets/${ticketId}/replies`,
    add: () => "student/tickets",
  },

  freeMaterials: {
    index: () => "student/free-material",
    enrollments: () => "student/free-material/enrollments",
    enroll: (courseId: number) => `student/free-material/${courseId}/enroll`,
    settings: () => "admin/free-material-settings",

    // done
    markAsDone: () => `student/free-material-student-progress`,
    removeDone: (materialId: number) =>
      `student/free-material-student-progress/${materialId}`,

    //reviews
    getReviews: (courseId: number) =>
      `student/free-material-courses/${courseId}/reviews`,
    addReview: (courseId: number) =>
      `student/free-material-courses/${courseId}/reviews`,
    editReview: (reviewId: number) =>
      `student/free-material-courses/reviews/${reviewId}`,
    deleteReview: (reviewId: number) =>
      `student/free-material-courses/reviews/${reviewId}`,
  },
} as const
